import React, { createContext, useContext, useMemo } from "react";

const SubdomainContext = createContext({
  subdomain: null,
  isApp: true,
  isPlatform: false,
  isClinic: false,
});

const getSubdomain = () => {
  const hostname = window.location.hostname;
  // hostname is e.g. "platform.onyx.bio", "app.localhost", or "localhost"
  const parts = hostname.split(".");
  if (parts.length > 1) {
    return parts[0]; // "platform", "app", etc.
  }
  return null; // bare "localhost" or single-segment hostname
};

export const SubdomainProvider = ({ children }) => {
  const value = useMemo(() => {
    const subdomain = getSubdomain();
    return {
      subdomain,
      isApp: subdomain !== "platform" && subdomain !== "clinic",
      isPlatform: subdomain === "platform",
      isClinic: subdomain === "clinic",
    };
  }, []);

  return (
    <SubdomainContext.Provider value={value}>
      {children}
    </SubdomainContext.Provider>
  );
};

export const useSubdomain = () => useContext(SubdomainContext);
